export enum Hub {
  Reno = 'reno',
  Chicago = 'chicago',
  Greenville = 'greenville',
  Columbus = 'columbus',
  Denver = 'denver',
  Fontana = 'fontana',
  Stockton = 'stockton',
}
